import {CARVAGO_URL} from '../../../constants/carvagoUrl';
import {REDIRECT_KEY, REDIRECT_SOURCE} from '../consts/REDIRECT_SOURCE';
import {composeQueryParams} from './composeQueryParams';

export function getCarvagoCarUrl(vehicle: {id: string; slug: string}) {
  const queryParams = composeQueryParams({[REDIRECT_KEY]: REDIRECT_SOURCE});

  return `${CARVAGO_URL}/car/${encodeURIComponent(vehicle.id)}/${encodeURIComponent(vehicle.slug)}?${queryParams.join('&')}`;
}
